/* eslint-disable react/jsx-curly-newline */
import {
  Card,
  CardActions,
  Button,
  CardContent,
  Box,
  Typography,
} from '@mui/material';
import React from 'react';

const AccordionCard = ({
  title,
  open,
  done,
  unfold,
  fold, // {label, onClick}
  children,
}) => (
  <Card>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ m: 2 }}
    >
      <Typography variant="h5">{title}</Typography>
      <CardActions>
        {open && (
          <Button
            color="primary"
            size="small"
            onClick={fold.onClick}
            sx={{ minWidth: 8 }}
            variant="contained"
          >
            {fold.label || '접기'}
          </Button>
        )}
        {open && (
          <Button
            color="secondary"
            size="small"
            onClick={done.onClick}
            disabled={done.disabled}
            sx={{ minWidth: 8 }}
            variant="contained"
          >
            {done.label || '완료'}
          </Button>
        )}
        {!open && (
          <Button
            color="secondary"
            size="small"
            onClick={unfold.onClick}
            sx={{ minWidth: 8 }}
            variant="contained"
          >
            {unfold.label || '펼치기'}
          </Button>
        )}
      </CardActions>
    </Box>
    {open && <CardContent>{children}</CardContent>}
  </Card>
);

export default AccordionCard;
